import { atomWithStorage } from "jotai/utils";

export const listParamsPreviewAtom = atomWithStorage(
  "list-params-preview",
  true,
  undefined,
  { getOnInit: true }
);
